module.exports = "/lucky-balls/img/weager/balls/color/red.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/red.png
// module id = 1182
// module chunks = 0